import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adm, apiErr } from "../../../lib/adminApi";
import { Sel, Badge } from "../ui";
import { money } from "../../../lib/api";

const FULFILLMENT = ["PENDING_FULFILLMENT", "PROCESSING", "SHIPPED", "DELIVERED", "ON_HOLD", "CANCELLED", "DIGITAL_DELIVERED"];

export default function OrdersTab() {
  const [orders, setOrders] = useState([]);
  const refresh = () => adm.orders().then(setOrders).catch(() => {});
  useEffect(() => { refresh(); }, []);

  const setStatus = async (o, status) => {
    try {
      await adm.dvFulfillment(o.order_number, status);
      toast.success(`${o.order_number} → ${status}`);
      refresh();
    } catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div data-testid="store-orders-tab">
      <p className="font-mono text-[9px] tracking-[0.25em] text-white/40 mb-5">
        ALL ORDERS — FULFILLMENT CHANGES FEED DIMENSION V QUALIFICATION AUTOMATICALLY.
      </p>
      {orders.length === 0 && <p className="text-white/40 text-sm">No orders yet.</p>}
      {orders.map((o) => (
        <div key={o.order_number} className="border-t border-white/10 py-4 px-2" data-testid={`order-row-${o.order_number}`}>
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div className="min-w-0">
              <p className="text-white/90 font-mono text-sm">{o.order_number}
                <span className="text-white/40 text-xs ml-3">{o.email || "guest"}</span>
              </p>
              <p className="font-mono text-[9px] text-white/40 mt-1 truncate">
                {(o.items || []).map((i) => `${i.name}${i.variantLabel ? ` (${i.variantLabel})` : ""} ×${i.quantity}`).join(" · ")}
              </p>
              <p className="font-mono text-[9px] text-white/30 mt-0.5">
                {money(o.amount)} · {String(o.created_at).slice(0, 10)}
                {o.promo_code && <span className="text-gold ml-2">PROMO {o.promo_code} (−{money(o.discount_amount || 0)})</span>}
              </p>
            </div>
            <div className="flex items-center gap-3 shrink-0">
              {o.qualifying_for_dimension_v && <Badge tone="gold">DV QUALIFYING</Badge>}
              <Badge tone={o.status === "confirmed" ? "green" : "dim"}>{(o.status || "").toUpperCase()}</Badge>
              <div className="w-52">
                <Sel label="" value={o.fulfillmentStatus || "PENDING_FULFILLMENT"} onChange={(v) => setStatus(o, v)}
                  options={FULFILLMENT.map((v) => ({ v, l: v.replace(/_/g, " ") }))} testid={`order-fulfillment-${o.order_number}`} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
